<template>
  <div class="c-a-link">
    <Input v-model="alink" :readonly="readonly" :disabled="disabled" :placeholder="placeholder" :clearable="clearable" />
    <div class="c-col-msg" v-if="msg">
      <span>{{ msg }}</span>
    </div>
  </div>
</template>
<script>
import { isEmpty } from '@/common/js/utils'
export default {
  name: 'aLink',
  props: {
    value: {
      type: String
    },
    name: {
      type: String
    },
    readonly: {
      type: String
    },
    disabled: {
      type: Boolean
    },
    placeholder: {
      type: String
    },
    verify: {
      type: Boolean
    },
    clearable: {
      type: Boolean
    },
    pattern: {
      type: String
    }
  },
  computed: {
    alink: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    msg() {
      if (this.readonly) return
      let err = ''
      const reg = new RegExp(this.pattern, 'g')
      if (this.verify && isEmpty(this.alink)) err = `${this.name}不能为空`
      else if (this.verify && this.pattern && !reg.test(this.alink)) err = `${this.name}不符合规则`
      return err
    }
  }
}
</script>
<style lang="scss" scoped>
.c-a-link {
  .c-col-msg {
    position: absolute;
    z-index: 997;
    bottom: -23px;
    color: #ff4400;
  }
}
</style>
